<ng-template #templateRef>
	<app-list-item-menu-container>
		<app-vehicle-road-worthy-check-delete-button
			(onDeleteCalled)="onDeleteResponse($event)"
			[id]="item().id"
			[code]="item().code" />
	</app-list-item-menu-container>
</ng-template>
